import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const LastOrders = () => {
    return (
        <div className="last-orders-wrapper">
            <div className="title xmb-6">
                <div className="title-box title-box-blue">
                    <div className="title-bg">
                        <h2 className="text">
                            آخرین سفارش ها
                        </h2>
                    </div>
                </div>
            </div>
            <div className="swiper last-orders-swiper">
                <div className="swiper-wrapper">
                    <table className="table position-relative swiper-slide">
                        <thead className="table-header">
                        <tr>
                            <th scope="col">تاریخ ثبت سفارش</th>
                            <th scope="col">کد سفارش</th>
                            <th scope="col">مبلغ کل</th>
                            <th scope="col">وضعیت</th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                                <td className="persian-number">۹ مرداد ۱۳۹۹</td>
                                <td>DKC-64215567</td>
                                <td className="persian-number">۳۲,۴۰۸,۰۰۰ تومان‌</td>
                                <td className="ok-payment"><IconName name="check_circle"
                                                                     className="icon"/>پرداخت
                                    موفق
                                </td>
                                <span className="more-icon position-absolute"><IconName name="chevron_left"
                                                                                        className="icon"/></span>
                            <a href="#" className="position-absolute"></a>
                        </tr>
                        <tr>
                            <td className="persian-number">۱۸ خرداد ۱۳۹۹</td>
                            <td>DKC-64215567</td>
                            <td className="persian-number">۳۲,۴۰۸,۰۰۰ تومان‌</td>
                            <td className="cancel-payment"><IconName name="info"
                                                                     className="icon"/>لغو شده
                            </td>
                            <span className="more-icon position-absolute"><IconName name="chevron_left"
                                                                                    className="icon"/></span>
                            <a href="#" className="position-absolute"></a>
                        </tr>
                        <tr>
                            <td className="persian-number">۱۸ خرداد ۱۳۹۹</td>
                            <td>DKC-64215567</td>
                            <td className="persian-number">۳۲,۴۰۸,۰۰۰ تومان‌</td>
                            <td className="error-payment"><IconName name="cancel"
                                                                    className="icon"/>پرداخت
                                ناموفق
                            </td>
                            <span className="more-icon position-absolute"><IconName name="chevron_left"
                                                                                    className="icon"/></span>
                            <a href="#" className="position-absolute"></a>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default LastOrders;
